import type { ReactNode } from "react";

import { GradientEllipseBackground } from "./GradientEllipseBackground";

interface GlowingBackgroundContainerProps {
  children: ReactNode;
}

export const GlowingBackgroundContainer = ({ children }: GlowingBackgroundContainerProps) => (
  <div className="rounded-mds relative size-full overflow-hidden">
    {/* SVG-фон, который ресайзится по Y и центрируется по X */}
    <GradientEllipseBackground />

    {/* Контент поверх — без z-index чтобы mix-blend-mode работал */}
    <div className="relative size-full">{children}</div>
  </div>
);
